import InputText from '@common_components/inputs/textInput.component';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface GraphicUnitSuffixInputProps {
  value: string;
  onChange: ( value: string ) => void;
  maxCharacter?: number;
  disable?: boolean;
  className?: string;
}

export const GraphicUnitSuffixInput: React.FC<GraphicUnitSuffixInputProps> = ( {
  value,
  onChange,
  maxCharacter = 25,
  disable = false,
  className = '',
} ) => {
  const { t } = useTranslation();

  return (
    <div className={`flex flex-col gap-1 ${className}`}>
      <InputText
        label={ t( 'translation:displayed_suffix', 'Suffixe affiché' ) }
        labelPosition='top'
        value={ value }
        onChange={ onChange }
        maxCharacter={ maxCharacter }
        disable={ disable }
      />
    </div>
  );
};
